module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем историю..."
    }
  }) : _c('div', {
    staticClass: "steamline"
  }, _vm._l((_vm.logs), function(log) {
    return _c('div', {
      staticClass: "sl-item"
    }, [_c('div', {
      staticClass: "sl-left"
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": _vm.getAvatarPath(log.user.avatar)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sl-right"
    }, [_c('div', [(_vm.user.isAdmin) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'ViewProfile',
          params: {
            id: log.user.id
          }
        }
      }
    }, [_vm._v(_vm._s(log.user.fullname))]) : _c('span', [_vm._v(_vm._s(log.user.fullname))]), _vm._v(" "), _c('span', {
      staticClass: "sl-date"
    }, [_vm._v(_vm._s(log.diffForHumans) + " (" + _vm._s(log.date) + " в " + _vm._s(log.time) + ")")])], 1), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(log.text))])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-f88d49d6"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Orders/OrderHistory.vue
// module id = 1078
// module chunks = 1